import axios from '@axios'

/**
 * Shared property-pin (place) type-ahead.
 *
 * Hits `cache-master/v1/place-autocomplete`, which exists only for this: it returns `id`,
 * the per-language `name` map and the place type, and nothing else.
 *
 * ⚠️ **Do not point this back at `cache-master/v1/place-filter`.** That is the pin *list*
 * query — it enriches every matched row with images, Google reviews, airport/BTS/MRT links,
 * zone and a property count (seven extra queries per row), and it only applies a `LIMIT` when
 * the caller sends `perpage`. Every autocomplete here used to send just `{ keyword }`, so a
 * two-character keyword answered with 573 rows and 6.3 MB after 17 seconds, and one character
 * matched 5,762 places. Measured after the move:
 *
 *   'as'      place-filter, no perpage → 573 rows, 6.3 MB, 17.1 s
 *   'as'      place-autocomplete       →  20 rows, 4.4 KB, 0.23 s
 *   'ideo'    place-autocomplete       →  20 rows, 4.4 KB, 0.21 s
 *
 * The response shape is the same as `place-filter`'s for the fields a suggestion row reads,
 * so `item.name[locale]` and `item.id` keep working untouched.
 */
export const MIN_PLACE_KEYWORD = 2

/**
 * ⚠️ Kept in step with the v3 `searchPropertyPins`, and with the `sectionConfigs[…].limit`
 * that `vue-autosuggest` applies on top of this on the property form — raising one without
 * the others silently caps the list again.
 */
export const searchPlaces = async (keyword, limit = 20) => {
  const trimmed = (keyword || '').trim()
  if (trimmed.length < MIN_PLACE_KEYWORD) return []

  const res = await axios.post('cache-master/v1/place-autocomplete', {
    keyword: trimmed,
    limit,
  })

  return res.data && res.data.data ? res.data.data : []
}
